// extracted by mini-css-extract-plugin
export default {"mainContent":"about-module--main-content--3A1C3","headshot":"about-module--headshot--2ILzx","textWrapper":"about-module--text-wrapper--3umkc"};